
import React, { PureComponent } from 'react'
// import { ApolloClient, ApolloLink, ApolloProvider, from, split, HttpLink, InMemoryCache } from '@apollo/client'
// import { getMainDefinition } from '@apollo/client/utilities';
// import { WebSocketLink } from '@apollo/client/link/ws';
// import { createUploadLink } from 'apollo-upload-client'
import { API_URL, SUBSCRIPTIONS_URL } from 'constants/API'
// import { SHOW_DEBUG } from 'constants/DEBUG'
import Loading from 'components/Loading'
// import generateTokenFromCookie from 'helpers/generateTokenFromCookie'

import GraphQLClientState from './_context/GraphQLClientState'

const KEEPALIVE_TIMEOUT = 7000;

export default class Apollo extends PureComponent {
  state = {
    client_is_initialized: false
  }

  render () {
    const {
      props: {
        children
      },
      state: {
        client_is_initialized
      }
    } = this

    if (!client_is_initialized) {
      return <Loading />
    }

    return (
      <GraphQLClientState>
        {children}
      </GraphQLClientState>
    );
  }

  componentDidMount () {
    this.setState(
      (state) => {
        return {
          ...state,
          client_is_initialized: true
        }
      }
    )
  }
}
